import { Injectable, Injector } from '@angular/core';
import { BaseService } from '../shared/services/base.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../shared/models/common.model';
import { LoginResponse } from '../shared/models/login.model';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AccountsService extends BaseService {
  constructor(injector: Injector) {
    super(injector);
  }

  login(data: Params): Observable<ApiResponse<LoginResponse>> {
    // @ts-ignore
    return this.http.post(`${this.apiUrl}auth/supporter-login`, JSON.stringify(data), this.httpOptions);
  }

  validateCard(data) {
    return this.http.post(`${this.apiUrl}public/supporter/validate-card-info`, JSON.stringify(data), this.httpOptions);
  }

  // register(data) {
  //   return this.http.post(`${this.apiUrl}auth/supporter-register`, JSON.stringify(data), this.httpOptions);
  // }

  getActiveClubs() {
    return this.http.get(`${this.apiUrl}public/club/get-active`, this.httpOptions);
  }

  generateNewMarchent(id) {
    return this.http.get(`${this.apiUrl}public/generate-marchent/${id}`, this.httpOptions);
  }

  getSelectedClubTeams(club_id) {
    return this.http.get(`${this.apiUrl}public/club/supporting-teams/${club_id}`, this.httpOptions);
  }

  identifyCard(data) {
    return this.http.post(`${this.apiUrl}public/transaction/card-identify`, JSON.stringify(data), this.httpOptions);
  }

  verifyToken(token) {
    return this.http.get(`${this.apiUrl}auth/verify/${token}`);
  }

  sendRecoveryCode(mobileNo) {
    return this.http.get(`${this.apiUrl}auth/password-recovery-code/${mobileNo}`);
  }

  sendRecoveryMail(email) {
    return this.http.get(`${this.apiUrl}auth/supporter-mail-password/${email}`);
  }

  verifyCodeforPassword(code, mobileNo) {
    return this.http.get(`${this.apiUrl}auth/verify-password-recovery/${code}/${mobileNo}`);
  }

  setSupporterPassword(data) {
    return this.http.put(`${this.apiUrl}auth/set-supporter-password`, JSON.stringify(data), this.httpOptions);
  }

  createSupporterPassword(data) {
    return this.http.put(`${this.apiUrl}auth/set-player-password`, JSON.stringify(data), this.httpOptions);
  }

  getCountyList() {
    return this.http.get(`${this.apiUrl}public/sl/counties`, this.httpOptions);
  }

  getCountryList() {
    return this.http.get(`${this.apiUrl}public/sl/countries`, this.httpOptions);
  }

  getSupporterExistemail(email) {
    return this.http.get(`${this.apiUrl}public/sl/supporter-exist-email/${email}`, this.httpOptions);
  }

  downloadTerms() {
    return this.http.get(`${this.apiUrl}public/supporter/download/terms-and-condition`, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/pdf'
      }
    });
  }

  // verifyCode(code, mobileNo) {
  //   return this.http.get(`${this.apiUrl}auth/verify-sms-code/${code}/${mobileNo}`);
  // }

  // resendCode(mobileNo) {
  //   return this.http.get(`${this.apiUrl}auth/resend-sms-code/${mobileNo}`);
  // }


  getSupporterExist(email, phone) {
    return this.http.get(`${this.apiUrl}public/sl/supporter-exist/${email}/${phone}`, this.httpOptions);
  }

  registerWithEmail(data) {
    return this.http.post(`${this.apiUrl}auth/supporter-register/with-email`, JSON.stringify(data), this.httpOptions);
  }

  getRegisterProcessingSupporter(id) {
    return this.http.get(`${this.apiUrl}auth/supporter/register-processing/${id}`, this.httpOptions);
  }

  verifyCodeForRegister(code, id) {
    return this.http.get(`${this.apiUrl}auth/verify-register-code/${code}/${id}`);
  }

  createRegisterPassword(data) {
    return this.http.post(`${this.apiUrl}auth/create-register-password`, JSON.stringify(data), this.httpOptions);
  }

  resendRegisterCode(id, sent_to) {
    return this.http.get(`${this.apiUrl}auth/resend-register-code/${id}?send_to=${sent_to}`);
  }

  fbUserLogin(data) {
    return this.http.post(`${this.apiUrl}auth/supporter-register/with-fb`, JSON.stringify(data), this.httpOptions);
  }

  updatePassword(data) {
    return this.http.post(`${this.apiUrl}public/supporter/password/change`, JSON.stringify(data), this.httpOptions);
  }

}
